<button
  [class]="cssClass"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [attr.aria-busy]="loading() ? 'true' : null"
>
  @if (loading()) {
    <span class="ui-button__spinner" aria-hidden="true"></span>
  }
  <span class="ui-button__label"><ng-content /></span>
</button>
